<template>
  <minimal-layout class="payment-processor">
    <v-container class="content-container">
      <v-container fluid class="component-container-1400mw">
        <v-container class="pa-0" style="max-width: 1200px; min-height: 500px;">
          <v-card class="mx-auto"
                  rounded="0"
                  elevation="15"
                  style="padding: 1.5rem;"
          >
            <v-row class="d-flex justify-center align-center">
              <v-col cols="12" sm="1" class="d-flex justify-center">
                <v-icon size="55" color="primary" icon="mdi-receipt-text-check"></v-icon>
              </v-col>
              <v-col cols="12" sm="11">
                <h3>{{ translation(translationList.order_placed, 'Comanda a fost plasată cu succes!') }}</h3>
                {{
                  translation(translationList.order_please_wait_redirect, 'Te rugăm să aștepți! În câteva secunde vei fi redirecționat automat pentru a efectua plata.')
                }}
              </v-col>
            </v-row>
            <v-row class="mt-10 mb-5">
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-progress-linear
                    indeterminate
                    color="primary"
                    striped
                    height="25"
                    class="slow-progress"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-container>
    </v-container>
    <div v-if="payment.paymentProcessorId === NETOPIA_PROCESSOR_ID">
      <v-form ref="netopiaForm" :action="payment.paymentUrl" method="post">
        <input type="hidden" name="env_key" :value="payment.result.env_key"/>
        <input type="hidden" name="data" :value="payment.result.enc_data"/>
        <input type="hidden" name="cipher" :value="payment.result.cipher"/>
        <input type="hidden" name="iv" :value="payment.result.iv"/>
      </v-form>
    </div>
    <div v-else-if="payment.paymentProcessorId === EUPLATESC_PROCESSOR_ID">
      <v-form ref="euPlatescForm" class="hidden" :action="payment.paymentUrl" method="POST" name="gateway"
              target="_self">
        <input name="fname" id="fname" :value="payment.result.fname" type="hidden"/>
        <input name="lname" id="lname" :value="payment.result.lname" type="hidden"/>
        <input name="country" id="country" :value="payment.result.country" type="hidden"/>
        <input name="company" type="hidden" :value="payment.result.company"/>
        <input name="city" id="city" type="hidden" :value="payment.result.city"/>
        <input name="add" id="address" type="hidden" :value="payment.result.address"/>
        <input name="email" id="email_ep" type="hidden" :value="payment.result.email"/>
        <input name="phone" id="phone" type="hidden" :value="payment.result.phone"/>
        <input name="fax" id="fax" type="hidden"/>
        <input type="hidden" name="amount" :value="payment.result.amount" id="euPlatesc-ammount"/>
        <input type="hidden" name="curr" :value="payment.result.curr" id="euPlatesc-currency"/>
        <input type="hidden" name="invoice_id" :value="payment.result.invoice_id"/>
        <input type="hidden" name="order_desc" :value="payment.result.order_desc"/>
        <input type="hidden" name="merch_id" :value="payment.result.merch_id"/>
        <input type="hidden" name="timestamp" :value="payment.result.timestamp"/>
        <input type="hidden" name="nonce" :value="payment.result.nonce"/>
        <input type="hidden" name="fp_hash" :value="payment.result.fp_hash"/>
      </v-form>
    </div>
  </minimal-layout>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, type PropType, nextTick} from 'vue';
import {useOrderStore} from "~/plugins/store/order";
import {useAuthStore} from "~/plugins/store/auth";
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";
import MinimalLayout from "~/layouts/MinimalLayout.vue";
import {useRoute} from "vue-router";

export default defineComponent({
  components: {MinimalLayout},
  props: {},
  setup() {
    const NETOPIA_PROCESSOR_ID = 4;
    const EUPLATESC_PROCESSOR_ID = 6;
    const MANUAL_PROCESSOR_ID = 3;
    const paymentProcessorId = ref<number | null>(null);
    const url = ref<string>('');
    const html = ref<string>('');
    const thankYouUrl = ref<string>('');
    const payment = ref({});
    const orderId = ref<number | null>(null);
    const orderStore = useOrderStore();
    const authStore = useAuthStore();
    const netopiaForm = ref<HTMLFormElement | null>(null);
    const euPlatescForm = ref<HTMLFormElement | null>(null);
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({}); // Initialize translations as a reactive reference
    const route = useRoute();

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      //retrieve orderId from query params
      const urlParams = new URLSearchParams(window.location.search);
      orderId.value = parseInt(urlParams.get('order_id') || '0');
      if (orderId.value === 0) {
        console.error('orderId is missing');
        await navigateTo('/');
        return;
      }

      let accessToken = authStore.getAccessToken();

      if (!accessToken) {
        if (typeof route.query.auth_token === 'string' && route.query.auth_token.length > 0) {
          accessToken = route.query.auth_token;
        }
      }

      payment.value = await orderStore.fetchPaymentRequest(orderId.value, <string>accessToken);
      console.log(payment.value);

      await nextTick(); // Asigură-te că formularul este montat

      console.log(payment.value.paymentProcessorId);

      if (NETOPIA_PROCESSOR_ID === payment.value.paymentProcessorId) {
        netopiaForm.value?.submit();
        console.log('Se trimite formularul Netopia.');
      } else if (EUPLATESC_PROCESSOR_ID === payment.value.paymentProcessorId) {
        setTimeout(() => {
          euPlatescForm.value?.submit();
          console.log('Se trimite formularul EuPlatesc.');
        }, 1500);
      }
    });

    return {
      translationList,
      translation,
      NETOPIA_PROCESSOR_ID,
      EUPLATESC_PROCESSOR_ID,
      MANUAL_PROCESSOR_ID,
      paymentProcessorId,
      url,
      html,
      thankYouUrl,
      payment,
      netopiaForm,
      euPlatescForm,
    };
  },
});
</script>

<style scoped>
/* Add your styles here */
</style>